import {
  WorkaroundDefinedType,
  WorkaroundTimelineCompliance,
} from '../../../../../shared/types/business-functions-workarounds';

export enum WorkaroundType {
  PROCESS_AREA = 'processArea',
  PROCESS = 'process',
}

export type ProcessAreasAndProcessesWorkaroundsDashboard = {
  getProcessAreaWorkaroundsDashboard: Dashboard[];
};

export type Dashboard = {
  uuid: string;
  name: string;
  revenue: number;
  applicationsTagged: number;
  completionPercentage: number;
  type: WorkaroundType;
  children: ChildrenWorkarounds[];
};

export type ChildrenWorkarounds = Omit<Dashboard, 'children'> & {
  parentUUID: string;
};

export type Workaround = {
  processAreaOrProcessId: string;
  itApplicationName: string;
  itApplicationId: string;
  locationId?: string;
  sla?: number;
  rto?: number;
  mto?: number;
  rpo?: number;
  isWorkaroundNeeded: boolean;
  workaroundDefined: WorkaroundDefinedType;
  runtimeHours?: number;
  maxDataLossHours?: number;
  workaroundDescription?: string;
  workaroundTimelineCompliance: WorkaroundTimelineCompliance;
  createdAt: Date;
  updatedAt: Date;
  workaroundUpdatedAt: Date;
};

export type ProcessAreaOrProcessWorkaround = {
  name: string;
  locationName: string;
  workarounds: Workaround[];
};

export type ProcessAreaOrProcessWorkaroundResponse = {
  getProcessAreaOrProcessWorkaround: ProcessAreaOrProcessWorkaround;
};
